import React, { useEffect, useRef, useCallback, useState } from "react"
import { useLocation } from "react-router-dom"
import PropTypes from "prop-types"
import axios from "axios"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import apiURl from "url"
import { Badge } from "reactstrap"

const SidebarContent = props => {
  const ref = useRef()
  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current?.recalculate()
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
    activeMenu()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  const role = localStorage.getItem("role")

  /** ---------------------------------------------
   * Unified Notifications State + APIs
   * ----------------------------------------------*/
  const [notifications, setNotifications] = useState({
    newRequest: 0, // /all_requests  (App)
    newCod: 0, // /cod-leads
    newRider: 0, // /rider-management
    newBusiness: 0, // /request-businesses
    newContactLead: 0, // /all-contact-leads
  })

  const fetchSidebarNotifications = async () => {
    try {
      const URL = `${apiURl}/sidebar-notifications`
      const { data } = await axios.get(URL)
      // Expected shape:
      // { newRequest, newCod, newRider, newBusiness, newContactLead }
      setNotifications(prev => ({ ...prev, ...data }))
    } catch (err) {
      console.error("Error fetching sidebar notifications", err)
    }
  }

  const markSeen = async type => {
    try {
      const URL = `${apiURl}/mark-seen`
      await axios.put(URL, { type }) // e.g., "newContactLead"
      setNotifications(prev => ({ ...prev, [type]: 0 }))
    } catch (err) {
      console.error("Error marking as seen", err)
    }
  }

  // Single polling loop (every 30s)
  useEffect(() => {
    fetchSidebarNotifications()
    const interval = setInterval(fetchSidebarNotifications, 30000)
    return () => clearInterval(interval)
  }, [])

  /** Red dot indicator (professional subtle look) */
  const RedDot = () => {
    return (
      <span
        style={{
          position: "absolute",
          top: 0, // Adjusted for larger badge
          right: -8, // Adjusted for balance
          minWidth: "5.5px",
          height: "5.5px",
          backgroundColor: "#dc3545", // Your red color
          color: "#fff",
          borderRadius: "9px", // Half of height for perfect circle
          fontSize: "10px",
          fontWeight: "600",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 4px rgba(220, 53, 69, 0.3)", // Subtle shadow for pro depth
          animation: "pulse 2s ease-in-out infinite", // Gentle pulse when active
          zIndex: 1, // Layers above text
        }}
      ></span>
    )
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled mt-3" id="side-menu">
            <li>
              <Link to="/#">
                <i className="bx bxs-dashboard"></i>
                <span>{props.t("Dashboards")}</span>
              </Link>
            </li>

            {/* Leads */}
            <li>
              <Link
                to="/#"
                className="has-arrow"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <i className="bx bx-folder-open"></i>
                  <span style={{ position: "relative", marginLeft: 4 }}>
                    {props.t("Leads")}
                    {notifications.newContactLead > 0 && <RedDot />}
                  </span>
                </div>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link
                    to="/all-contact-leads"
                    onClick={() => markSeen("newContactLead")}
                  >
                    {props.t("All")}
                    {notifications.newContactLead > 0 && (
                      <Badge className="mx-2 bg-blue" color="primary">
                        new
                      </Badge>
                    )}
                  </Link>
                </li>
                <li>
                  <Link to="/new-contact-leads">{props.t("New")}</Link>
                </li>
                <li>
                  <Link to="/pending-contact-leads">{props.t("Pending")}</Link>
                </li>
                <li>
                  <Link to="/active-contact-leads">{props.t("Activated")}</Link>
                </li>
                <li>
                  <Link to="/leads-setting">{props.t("Setting")}</Link>
                </li>
              </ul>
            </li>

            {/* Shippers */}
            <li>
              <Link
                to="/#"
                className="has-arrow"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i className="bx bxs-package"></i>
                  <span style={{ position: "relative", marginLeft: 4 }}>
                    {props.t("Shippers")}
                    {notifications.newBusiness > 0 && <RedDot />}
                  </span>
                </div>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link
                    to="/request-businesses"
                    onClick={() => markSeen("newBusiness")}
                  >
                    {props.t("Pending")}
                    {notifications.newBusiness > 0 && (
                      <Badge className="mx-2 bg-blue" color="primary">
                        new
                      </Badge>
                    )}
                  </Link>
                </li>
                <li>
                  <Link to="/approved-business">{props.t("Active")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Blocked/Deleted")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Shippers Map")}</Link>
                </li>
                <li>
                  <Link to="/cod-service-charges">{props.t("Rate Card")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Review/Suggestion")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Setting")}</Link>
                </li>
              </ul>
            </li>

            {/* Consignees */}
            <li>
              <Link
                to="/#"
                className="has-arrow"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i className="bx bx-user-pin"></i>
                  <span>{props.t("Consignees")}</span>
                </div>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/#">{props.t("Domestic")}</Link>
                </li>
                <li>
                  <Link to="/int-consignees">{props.t("International")}</Link>
                </li>
              </ul>
            </li>

            {/* International */}
            <li>
              <Link
                to="/#"
                className="has-arrow"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i className="bx bxs-plane-take-off"></i>
                  <span>{props.t("International")}</span>
                </div>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link
                    to="/#"
                    className="has-arrow"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {props.t("Book")}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/int-booking">{props.t("Order Form")}</Link>
                    </li>
                    <li>
                      <Link to="/int-booking">
                        {props.t("Bulk Booking (Excel)")}
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#">{props.t("Dox")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Track")}</Link>
                </li>
                <li>
                  <Link to="/int-bookings">{props.t("History")}</Link>
                </li>

                <li>
                  <Link
                    to="/#"
                    className="has-arrow"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {props.t("Rates/Services")}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/int-carriers">{props.t("Carriers")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/int-setting">{props.t("Setting")}</Link>
                </li>
              </ul>
            </li>

            {/* Bookings */}
            <li>
              <Link
                to="/#"
                className="has-arrow"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i className="bx bxs-book-content"></i>
                  <span>{props.t("Bookings")}</span>
                </div>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/#">{props.t("Order Management")}</Link>
                </li>
                <li>
                  <Link
                    to="/#"
                    className="has-arrow"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {props.t("Book")}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/courier_info">
                        {props.t("Single Shipment")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Bulk (Excel)")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Cancel/Void")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link
                    to="/#"
                    className="has-arrow"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {props.t("Load Sheet")}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/#">{props.t("Create")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Create By Scan")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Excel")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Canceled ")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("History")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Setting")}</Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

            {/* Shipments */}
            <li>
              <Link
                to="/#"
                className="has-arrow"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <i className="bx bxs-customize"></i>
                  <span style={{ position: "relative", marginLeft: 4 }}>
                    {props.t("Shipments")}
                    {notifications.newCod > 0 && <RedDot />}
                  </span>
                </div>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/all_parcel_detail">{props.t("All")}</Link>
                </li>
                <li>
                  <Link to="/today_book">{props.t("Today")}</Link>
                </li>

                <li>
                  <Link
                    to="/cod-leads"
                    style={{ display: "flex", alignItems: "center" }}
                    onClick={() => markSeen("newCod")}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ marginRight: "2px" }}>
                        {props.t("COD")}
                      </span>
                    </div>
                    {notifications.newCod > 0 && (
                      <Badge className="mx-2 bg-blue" color="primary">
                        new
                      </Badge>
                    )}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/all_requests"
                    style={{ display: "flex", alignItems: "center" }}
                    onClick={() => markSeen("newRequest")}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ marginRight: "8px" }}>
                        {props.t("App")}
                      </span>
                    </div>
                    {notifications.newRequest > 0 && (
                      <Badge className="mx-2 bg-blue" color="primary">
                        new
                      </Badge>
                    )}
                  </Link>
                </li>
              </ul>
            </li>

            {/* Tracking */}
            <li>
              <Link
                to="/#"
                className="has-arrow"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i className="bx bx-barcode"></i>
                  <span>{props.t("Tracking")}</span>
                </div>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/#">{props.t("Search")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Bulk")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("International")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Advance Search")}</Link>
                </li>
              </ul>
            </li>

            {/* First Mile */}
            <li>
              <Link
                to="/#"
                className="has-arrow"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i className="bx bxs-layer"></i>
                  <span>{props.t("First Mile")}</span>
                </div>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link
                    to="/#"
                    className="has-arrow"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {props.t("Pickup")}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/#">{props.t("Pending")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Arrived ECS")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Arrived 3PLs")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Individual Arrival")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Bulk Arrival")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Rider Pickups")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Rider Action log")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Rider Receiving")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Pickup Route")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Weight Correction")}</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#">{props.t("History")}</Link>
                </li>
              </ul>
            </li>

            {/* Mid Mile */}
            <li>
              <Link
                to="/#"
                className="has-arrow"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i className="bx bxs-layer"></i>
                  <span>{props.t("Mid Mile")}</span>
                </div>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/#">{props.t("Sorting")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Bagging ECS")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Bagging 3PLs")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Transit")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Destination Arrival")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Debagging")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Short/Missing/Damage")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Setting")}</Link>
                </li>
              </ul>
            </li>

            {/* Last Mile */}
            <li>
              <Link
                to="/#"
                className="has-arrow"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i className="bx bxs-layer"></i>
                  <span>{props.t("Last Mile")}</span>
                </div>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/#">{props.t("Dashboard")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Riders")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Run Sheet")}</Link>
                </li>
                <li>
                  <Link
                    to="/#"
                    className="has-arrow"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {props.t("Delivery")}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/#">{props.t("Pending")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Create Note")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Quick Receive")}</Link>
                    </li>
                    <li>
                      <Link
                        to="/#"
                        className="has-arrow"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        {props.t("Pending Cash Collection")}
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link to="/#">{props.t("COD")}</Link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <Link
                        to="/#"
                        className="has-arrow"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        {props.t("Completed")}
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link to="/#">{props.t("COD")}</Link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <Link to="/#">{props.t("History")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Reason")}</Link>
                    </li>
                    <li>
                      <Link
                        to="/#"
                        className="has-arrow"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        {props.t("Return")}
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link to="/#">{props.t("Confirmed")}</Link>
                        </li>
                        <li>
                          <Link to="/#">{props.t("Create Note")}</Link>
                        </li>
                        <li>
                          <Link to="/#">{props.t("Return Sheet")}</Link>
                        </li>
                        <li>
                          <Link to="/#">
                            {props.t("Return Deliver to Shipper")}
                          </Link>
                        </li>
                        <li>
                          <Link to="/#">{props.t("Return Pending")}</Link>
                        </li>
                        <li>
                          <Link to="/#">{props.t("History")}</Link>
                        </li>
                        <li>
                          <Link to="/#">{props.t("Setting")}</Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

            {/* Finance */}
            <li>
              <Link
                to="/#"
                className="has-arrow"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i className="bx bxs-bank"></i>
                  <span>{props.t("Finance")}</span>
                </div>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link
                    to="/#"
                    className="has-arrow"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {props.t("Receiveables")}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/#">{props.t("A")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("B")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("C")}</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link
                    to="/#"
                    className="has-arrow"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {props.t("Payables")}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/#">{props.t("A")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("B")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("C")}</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link
                    to="/#"
                    className="has-arrow"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {props.t("International")}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link
                        to="/#"
                        className="has-arrow"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        {props.t("Invoices")}
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link to="/#">{props.t("ECS")}</Link>
                        </li>
                        <li>
                          <Link to="/#">{props.t("3PLs")}</Link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Credit")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Debit")}</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link
                    to="/#"
                    className="has-arrow"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {props.t("COD Payments")}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/#">{props.t("Make")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Done")}</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link
                    to="/#"
                    className="has-arrow"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {props.t("Invoices")}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/#">{props.t("ECS")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("3PLs")}</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link
                    to="/#"
                    className="has-arrow"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {props.t("Recovery")}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/#">
                        {props.t("SDN (Station Deposit Notes)")}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link
                    to="/#"
                    className="has-arrow"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {props.t("Petty Cash")}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/#">{props.t("Make")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Statement")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Approved")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Rejected")}</Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

            {/* CRM */}
            <li>
              <Link
                to="/#"
                className="has-arrow"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i className="bx bxs-widget"></i>
                  <span>{props.t("CRM")}</span>
                </div>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link
                    to="/#"
                    className="has-arrow"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {props.t("Requests")}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/#">{props.t("Launched")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("In Process")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Pending")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Resolved")}</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#">{props.t("Bulk Logging")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Agents")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Query Routing")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Consignee Info")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Setting")}</Link>
                </li>
              </ul>
            </li>

            {/* Business Control */}
            <li>
              <Link
                to="/#"
                className="has-arrow"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <i className="bx bxl-shopify"></i>
                  <span style={{ position: "relative", marginLeft: 4 }}>
                    {props.t("Business Control")}
                    {/* {notifications.newBusiness > 0 && <RedDot />} */}
                  </span>
                </div>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/cod-service-type">{props.t("Service Types")}</Link>
                </li>
                <li>
                  <Link to="/cod-business/wallet">
                    {props.t("Business Wallet")}
                  </Link>
                </li>
              </ul>
            </li>

            {/* Riders Control */}
            <li>
              <Link
                to="/#"
                className="has-arrow"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <i className="bx bx-cycling"></i>
                  <span style={{ position: "relative", marginLeft: 4 }}>
                    {props.t("Riders Control")}
                    {notifications.newRider > 0 && <RedDot />}
                  </span>
                </div>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link
                    to="/rider-management"
                    onClick={() => markSeen("newRider")}
                  >
                    {props.t("All Riders")}
                    {notifications.newRider > 0 && (
                      <Badge className="mx-2 bg-blue" color="primary">
                        new
                      </Badge>
                    )}
                  </Link>
                </li>
                <li>
                  <Link to="/rider-wallet">{props.t("Riders Wallet")}</Link>
                </li>
              </ul>
            </li>

            {/* Operation Support */}
            <li>
              <Link
                to="/#"
                className="has-arrow"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i className="bx bxs-help-circle"></i>
                  <span>{props.t("Operation Support")}</span>
                </div>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/#">
                    {props.t("ODR (Operation Disorder Report)")}
                  </Link>
                </li>
              </ul>
            </li>

            {/* Support */}
            <li>
              <Link
                to="/#"
                className="has-arrow"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i className="bx bx-support"></i>
                  <span>{props.t("Support")}</span>
                </div>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/#">{props.t("Directory Internal")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("3PLs Directory")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Scanning History")}</Link>
                </li>
                <li>
                  <Link
                    to="/#"
                    className="has-arrow"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {props.t("Vigilance")}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/#">{props.t("History")}</Link>
                    </li>
                    <li>
                      <Link to="/#">{props.t("Writer Remarks")}</Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

            {/* Reports */}
            <li>
              <Link
                to="/#"
                className="has-arrow"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i className="bx bxs-report"></i>
                  <span>{props.t("Reports")}</span>
                </div>
              </Link>
              <ul
                className="sub-menu"
                style={{ listStyleType: "disc", paddingLeft: "20px" }}
              >
                <li>
                  <Link to="/#">
                    {props.t("Book vs Received vs Delivered vs Return")}
                  </Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Pick up Notes Completed")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Cargo Received")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Weight QC")}</Link>
                </li>
                <li>
                  <Link to="/#">
                    {props.t("Route History Initial Summary")}
                  </Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Short Received Shipments")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Last Mile Status")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Pick up History")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Rider pickup report")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("QSR (Quality Of Service)")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Overall Sales")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Daily Pickup & Sales")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Salesperson Performance")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Monthly Shipper Wise Sales")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Negative Balance")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("3PLs Business Report")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Summary")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Daily Visits")}</Link>
                </li>
                <li>
                  <Link to="/#">
                    {props.t("ODR (Operation Disorder Report)")}
                  </Link>
                </li>
              </ul>
            </li>

            {/* HR */}
            <li>
              <Link
                to="/#"
                className="has-arrow"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i className="bx bx-briefcase"></i>
                  <span>{props.t("HR")}</span>
                </div>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/users">{props.t("Employee List")}</Link>
                </li>
                <li>
                  <Link to="/app-users">{props.t("App Users")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Payroll")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Salary Slip")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Designations")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Setting")}</Link>
                </li>
              </ul>
            </li>

            {/* Setting */}
            <li>
              <Link
                to="/#"
                className="has-arrow"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <i className="bx bx-cog"></i>
                  <span>{props.t("Setting")}</span>
                </div>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/services_categories">{props.t("Services")}</Link>
                </li>
                <li>
                  <Link to="/#">{props.t("Role Management")}</Link>
                </li>
                <li>
                  <Link to="/manage-zone">{props.t("Network Management")}</Link>
                </li>

                <li>
                  <Link to="/controls">{props.t("Controls")}</Link>
                </li>
              </ul>
            </li>

            {role === "admin" && <></>}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
